/**
 * Locale (es-ES) — copy específica del listado moderno de Solicitudes.
 * Solo agregamos llaves nuevas; reutilizamos las existentes en
 * `applications/locales/es-ES.js` para origen, estados, etc.
 */
export default {
  'applicationsModern.title': 'Solicitudes',
  'applicationsModern.summary': 'Consulta solicitudes, filtra por estado y abre su detalle.',
  'applicationsModern.refresh': 'Actualizar',

  'applicationsModern.detail.back': 'Volver',
  'applicationsModern.detail.titlePrefix': 'Detalle de la solicitud',
  'applicationsModern.detail.configure': 'Configurar',
  'applicationsModern.detail.refresh': 'Actualizar',
  'applicationsModern.bulkDetail.titlePrefix': 'Detalles de Tarea Carga Masiva',
  'applicationsModern.bulkDetail.description':
    'Consulta los detalles de la tarea de carga masiva, el archivo y los ítems procesados.',

  'applicationsModern.section.eyebrow': 'Resultados',
  'applicationsModern.section.title': 'Solicitudes encontradas',
  'applicationsModern.section.kicker': 'Mostrando {shown} de {total} solicitudes',
  'applicationsModern.section.kickerEmpty': 'Sin coincidencias con los filtros activos',

  'applicationsModern.empty.title': 'No encontramos solicitudes',
  'applicationsModern.empty.description':
    'Ajusta los filtros o el rango de fechas para ver más resultados.',
  'applicationsModern.empty.descriptionFor':
    'No hay solicitudes en "{origin}" con los filtros actuales. Prueba cambiando la fecha, el estado o el origen.',
  'applicationsModern.filters.toggle': 'Filtros',
  'applicationsModern.toolbar.order.desc': 'Reciente',
  'applicationsModern.toolbar.order.asc': 'Antiguo',
  'applicationsModern.filters.clearAll': 'Limpiar todos',
  'applicationsModern.filters.from': 'Desde',
  'applicationsModern.filters.to': 'Hasta',
  'applicationsModern.filters.remove': 'Quitar',
  // Aliases globales (sólo si no existen aún en common.js)
  'global.text.from': 'Desde',
  'global.text.to': 'Hasta',
  'global.button.remove': 'Quitar',
};
